<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6oPNQL/tc-custom/9781504082730.jpg?1705025993224" alt="This image is the cover for the book Nightmare Carnival"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nightmare Carnival
      </h1>
      <p class="bookDescription body article font2">
        <b>Encounter the scariest clowns and freakiest curiosities under the big top, in stories by Stephen Graham Jones, Laird Barron, Priya Sharma, and others.</b><br/><br/><i>With an introduction from Katherine Dunn</i><br/><br/> Ladies and gentlemen, step right up for fifteen tales of terrifying rides, supernatural sideshows, and petrifying performers guaranteed to keep you up all night—with Hugo and Bram Stoker Award–winning editor Ellen Datlow as the ringmaster.<br/><br/> In Stephen Graham Jones’s “The Darkest Part,” three men are driven to madness by the clown that has haunted them since one misguided Tunnel of Love ride during their childhoods. The deaths of three circus performers—two brothers and a beautiful fire dancer—become the burning obsession of an author who wrote a book about the tragedy in “The Firebrand” by Priya Sharma. “Skullpocket” by Nathan Ballingrud takes you to an alternate fantasy world where a well-respected ghoul from a town near Chesapeake Bay grieves the death of his one true love, a freak show attraction known as the Orchid Girl.<br/><br/> Under the tent, you’ll find more chilling stories by Genevieve Valentine, Robert Shearman, N.  Lee Wood, Nick Mamatas, A. C. Wise, Terry Dowling, Joel Lane, Glen Hirshberg, Jeffrey Ford, Dennis Danvers, and Livia Llewellyn.<br/><br/> “To Datlow’s credit a number of her selections take the dark carnival theme into provocative new territory. . . . Ballingrud’s tale is a magnificent piece of storytelling. Accompanied by another 14 estimable acts, it makes admission into <i>Nightmare Carnival</i> well worth the price.” —<i>Locus</i><br/><br/> “There’s not a bad story in the bunch.” —<i>Horror DNA</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Datlow, Katherine Dunn, N. Lee Wood, Priya Sharma, Nick Mamatas, A.C. Wise, Terry Dowling, Joel Lane, Glen Hirshberg, Jeffrey Ford, Dennis Danvers, Genevieve Valentine, Stephen Graham Jones, Robert Shearman, Nathan Ballingrud, Laird Barron, Livia Llewellyn
      </h2>
      
      <p class="authorDescription body article">Ellen Datlow, an acclaimed science fiction and fantasy editor, was born and raised in New York City. She has been a short story and book editor for more than thirty years and has edited or coedited several critically acclaimed anthologies of speculative fiction, including the Year&rsquo;s Best Fantasy and Horror series and <I>Black Thorn, White Rose </I>(1994) with Terri Windling. Datlow has received numerous honors, including multiple Shirley Jackson, Bram Stoker, Hugo, Locus, and World Fantasy Awards, and Life Achievement Awards from the&#160;Horror Writers Association and the World Fantasy Association, to name just a few. She resides in New York. &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10f999d5